import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { KibTextarea } from '@chewy/kib-fields-new-react'

import { usePaymentRequestDialog } from '../context/PaymentRequestDialogProvider'

import '@chewy/kib-fields-new-styles/dist/styles/kib-field.css'
import styles from './ClinicNotesSection.module.scss'

export const ClinicNotesSection = ({
  isFormValid,
  setIsFormValid,
}: {
  isFormValid: boolean
  setIsFormValid: (isValid: boolean) => void
}) => {
  const { t } = useTranslation(['Dialogs'])
  const { actions, dialogState } = usePaymentRequestDialog()
  useEffect(() => {
    setIsFormValid(dialogState.clinicNotes.length <= 200)
  }, [dialogState.clinicNotes, setIsFormValid])

  return (
    <section className={styles.clinicNotesSection}>
      <KibTextarea
        className={styles.clinicNotesField}
        invalid={!isFormValid}
        label={t('Dialogs:PAYMENT_REQUEST_DIALOG_V2.NOTES_FROM_CLINIC_LABEL')}
        messagesContent={
          !isFormValid
            ? t(
                'Dialogs:PAYMENT_REQUEST_DIALOG_V2.NOTES_FROM_CLINIC_TOO_LONG',
                {
                  maxLength: 200,
                },
              )
            : undefined
        }
        placeholder={t('Dialogs:PAYMENT_REQUEST_DIALOG_V2.NOTES_FOR_CUSTOMER')}
        value={dialogState.clinicNotes}
        onChange={(e) => actions.setClinicNotes(e.target.value)}
      />
    </section>
  )
}
